var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLifetimeValue = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6248 5.49982V11.7498C14.6248 12.4373 14.0623 12.9998 13.3748 12.9998H3.37476C3.03101 12.9998 2.74976 12.7186 2.74976 12.3748C2.74976 12.0311 3.03101 11.7498 3.37476 11.7498H13.3748V5.49982C13.3748 5.15607 13.656 4.87482 13.9998 4.87482C14.3435 4.87482 14.6248 5.15607 14.6248 5.49982ZM2.74976 10.4998C1.71226 10.4998 0.874756 9.66232 0.874756 8.62482V4.87482C0.874756 3.83732 1.71226 2.99982 2.74976 2.99982H10.2498C11.2873 2.99982 12.1248 3.83732 12.1248 4.87482V9.24982C12.1248 9.93732 11.5623 10.4998 10.8748 10.4998H2.74976ZM4.62476 6.74982C4.62476 7.78732 5.46226 8.62482 6.49976 8.62482C7.53726 8.62482 8.37475 7.78732 8.37475 6.74982C8.37475 5.71232 7.53726 4.87482 6.49976 4.87482C5.46226 4.87482 4.62476 5.71232 4.62476 6.74982Z",
    fill: "#0052CC"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLifetimeValue, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/lifetime_value.188b004c.svg";
export { ForwardRef as ReactComponent };